<section class="attention-card">
  <h2 class="attention-title">Accounts Needing Attention</h2>

  <div class="attention-scroll">
    <div *ngIf="loading" class="flex items-center justify-center py-10">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>

    <p *ngIf="!loading && items.length === 0" class="attention-empty">
      {{ emptyMessage }}
    </p>

    <ul *ngIf="!loading && items.length > 0" class="attention-list">
      <li *ngFor="let item of items" class="attention-row">
        <span class="reason-badge" [class.reason-badge--lapsed]="item.reason !== 'PastDue30'">{{ badgeLabel(item) }}</span>
        <div class="attention-body">
          <div class="client-name">{{ item.clientName }}</div>
          <div class="attention-meta">{{ subtitle(item) }}</div>
        </div>
        <a class="action-link" [routerLink]="actionLink(item)">{{ actionLabel(item) }}</a>
      </li>
    </ul>
  </div>
</section>
